module.exports = __webpack_public_path__ + "quote-bottom.png?9ea28ff8b0f4c395990d9c15909f8bbe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quote-bottom.png
// module id = 13
// module chunks = 0